import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { updateAnalyticsRoute } from '../lib/analytics';

export default function AnalyticsRouteTracker() {
  const { pathname } = useLocation();
  const last = useRef(null);
  useLayoutEffect(() => {
    if (last.current === pathname) return;
    last.current = pathname;
    void updateAnalyticsRoute(pathname);
  }, [pathname]);
  return null;
}
